export const DELETE_BANNER_REQUEST = "DELETE_BANNER_REQUEST"
export const DELETE_BANNER_SUCCESS = 'DELETE_BANNER_SUCCESS'
export const DELETE_BANNER_FAIL = 'DELETE_BANNER_FAIL'
export const DELETE_BANNER_RESET = "DELETE_BANNER_RESET"

export const CREATE_BANNER_REQUEST = "CREATE_BANNER_REQUEST"
export const CREATE_BANNER_SUCCESS = 'CREATE_BANNER_SUCCESS'
export const CREATE_BANNER_FAIL = 'CREATE_BANNER_FAIL'
export const CREATE_BANNER_RESET = 'CREATE_BANNER_RESET'

export const GET_BANNER_REQUEST = "GET_BANNER_REQUEST"
export const GET_BANNER_SUCCESS = 'GET_BANNER_SUCCESS'
export const GET_BANNER_FAIL = 'GET_BANNER_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS' 